export const UPLOAD_STATUS = {
    UPLOADED: 'Uploaded',
    PROCESSING: 'Processing',
    ERROR: 'Rejected',
    SUCCESS: 'Completed'
}
